import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f06aa4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "股份流通受阻", -1))
const _hoisted_3 = { class: "sdltgdchartslist" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lengend" }, [
  /*#__PURE__*/_createElementVNode("span", null, " "),
  /*#__PURE__*/_createElementVNode("span", null, "类型"),
  /*#__PURE__*/_createElementVNode("span", null, "数量"),
  /*#__PURE__*/_createElementVNode("span", null, "比例")
], -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "流通股份分布", -1))
const _hoisted_7 = { class: "sdltgdchartslist" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lengend" }, [
  /*#__PURE__*/_createElementVNode("span", null, " "),
  /*#__PURE__*/_createElementVNode("span", null, "类型"),
  /*#__PURE__*/_createElementVNode("span", null, "数量"),
  /*#__PURE__*/_createElementVNode("span", null, "比例")
], -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      (_ctx.list1.length && _ctx.list2.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_2,
                _createVNode(_component_Charts, {
                  id: "ltgfjgt",
                  option: _ctx.option
                }, null, 8, ["option"]),
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list1, (item, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "clearfix",
                        key: 'list1' + i
                      }, [
                        _createElementVNode("span", null, [
                          (item.color)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                style: _normalizeStyle({'background-color': item.color})
                              }, null, 4))
                            : (_openBlock(), _createElementBlock("i", _hoisted_5, " "))
                        ]),
                        _createElementVNode("span", null, _toDisplayString(item.title), 1),
                        _createElementVNode("span", null, _toDisplayString(Math.abs(item.num) >= 100000000 ?  (item.num / 100000000).toFixed(2) + '亿': Math.abs(item.num) >= 10000 ? (item.num / 10000).toFixed(2) + '万' : parseFloat(item.num).toString() !== 'NaN' ? item.num : '—'), 1),
                        _createElementVNode("span", null, _toDisplayString(item.ratio ? item.ratio : '—'), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _hoisted_6,
                _createVNode(_component_Charts, {
                  id: "sdltgfjgt",
                  option: _ctx.option2
                }, null, 8, ["option"]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (item, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "clearfix",
                        key: 'list2' + i
                      }, [
                        _createElementVNode("span", null, [
                          (item.color)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                style: _normalizeStyle({'background-color': item.color})
                              }, null, 4))
                            : (_openBlock(), _createElementBlock("i", _hoisted_9, " "))
                        ]),
                        _createElementVNode("span", null, _toDisplayString(item.title), 1),
                        _createElementVNode("span", null, _toDisplayString(Math.abs(item.num) >= 100000000 ?  (item.num / 100000000).toFixed(2) + '亿': Math.abs(item.num) >= 10000 ? (item.num / 10000).toFixed(2) + '万' : parseFloat(item.num).toString() !== 'NaN' ? item.num : '—'), 1),
                        _createElementVNode("span", null, _toDisplayString(item.ratio ? item.ratio : '—'), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_10, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}